import img1 from "../assets/gallery/Uzbekistan/uzbekistan1.jpg";
import img2 from "../assets/gallery/Uzbekistan/uzbekistan2.jpg";
import img3 from "../assets/gallery/Uzbekistan/uzbekistan3.jpg";
import img4 from "../assets/gallery/Uzbekistan/uzbekistan4.jpg";
import img5 from "../assets/gallery/Uzbekistan/uzbekistan5.jpg";
import img6 from "../assets/gallery/Uzbekistan/uzbekistan6.jpg";
import img7 from "../assets/gallery/Uzbekistan/uzbekistan7.jpg";
import img8 from "../assets/gallery/Uzbekistan/uzbekistan8.jpg";
import img9 from "../assets/gallery/Uzbekistan/uzbekistan9.jpg";
import img10 from "../assets/gallery/Uzbekistan/uzbekistan10.jpg";
import img11 from "../assets/gallery/Uzbekistan/uzbekistan11.jpg";
import img12 from "../assets/gallery/Uzbekistan/uzbekistan12.jpg";
import img13 from "../assets/gallery/Uzbekistan/uzbekistan13.jpg";
import img14 from "../assets/gallery/Uzbekistan/uzbekistan14.jpg";
import img15 from "../assets/gallery/Uzbekistan/uzbekistan15.jpg";
import img16 from "../assets/gallery/Uzbekistan/uzbekistan16.jpg";
import img17 from "../assets/gallery/Uzbekistan/uzbekistan17.jpg";

const uzbekistanGallery = [
  { img: img1, colSpan: 2, rowSpan: 2 }, // hero
  { img: img2 },
  { img: img3 },
  { img: img4 },

  { img: img5 },
  { img: img6 },
  { img: img7, rowSpan: 2,colSpan: 2 },
  { img: img8 },
  { img: img9, colSpan: 2 },

  { img: img10 },
  { img: img11 },
  { img: img12 },
  { img: img13 },
  { img: img14 },

  { img: img15 },
  { img: img16 },
  { img: img17 },
];

export default uzbekistanGallery;
